import { render, staticRenderFns } from "./MaterialEmployee.vue?vue&type=template&id=cb5ac2cc"
import script from "./MaterialEmployee.vue?vue&type=script&lang=js"
export * from "./MaterialEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports